// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__AStgn","total":"Cart_total__2XJ+2","actions":"Cart_actions__xZYyv","button--alt":"Cart_button--alt__614Uc","button":"Cart_button__O+dqZ"};